import 'bootstrap/js/dist/modal';
import {EMAIL_EXISTED, EMAIL_NOT_EXISTED, USERNAME_INVALID, WRONG_PASSWORD} from 'Core/error-codes';

const ERROR_CLASS = 'modal-form__item--error';
const SUBSCRIPTION_ERROR_CLASS = 'form-input--error';

const ERROR_STATUS_VALIDATION_FORM = 417;

export const renderErrorByResponse = (response, parent) => {
    if (response.status !== undefined && response.status === ERROR_STATUS_VALIDATION_FORM) {
        for (const field in JSON.parse(response.data.message)) {
            parent.find(`input[name="${field}"]`).parents('.form-input').addClass(ERROR_CLASS);
        }
    }

    if (response.data.code === 0) {
        return;
    }

    parent.find('input[name="name"]').parents('.modal-form__item').removeClass(ERROR_CLASS);
    parent.find('input[name="password"]').parents('.modal-form__item').removeClass(ERROR_CLASS);
    parent.find('input[name="email"]').parents('.modal-form__item').removeClass(ERROR_CLASS);
    parent.find('input[name="confirm_password"]').parents('.modal-form__item').removeClass(ERROR_CLASS);

    switch (response.data.code) {
        case USERNAME_INVALID:
            parent.find('input[name="name"]').parents('.modal-form__item').addClass(ERROR_CLASS);
            parent.find('input[name="name"]')
                .parents('.modal-form__item')
                .find('.modal-form__label-error')
                .text(response.data.error);
            break;

        case EMAIL_EXISTED:
        case EMAIL_NOT_EXISTED:
            parent.find('input[name="email"]').parents('.modal-form__item').addClass(ERROR_CLASS);
            parent.find('input[name="email"]')
                .parents('.modal-form__item')
                .find('.modal-form__label-error')
                .text(response.data.error);
            break;

        case WRONG_PASSWORD:
            parent.find('input[name="password"]').parents('.modal-form__item').addClass(ERROR_CLASS);
            parent.find('input[name="password"]')
                .parents('.modal-form__item')
                .find('.modal-form__label-error')
                .text(response.data.error);
            parent.find('input[name="confirm_password"]').parents('.modal-form__item').addClass(ERROR_CLASS);
            parent.find('input[name="confirm_password"]')
                .parents('.modal-form__item')
                .find('.modal-form__label-error')
                .text(response.data.error);
            break;
    }
};

export const renderSubscriptionErrorByResponse = (response, parent) => {
    if (response.status === undefined || response.status !== ERROR_STATUS_VALIDATION_FORM) {
        return;
    }

    parent.find(`input[name="email"]`).parents('.form-input').addClass(SUBSCRIPTION_ERROR_CLASS);
};
